(() => {
 if(customElements.get('rp-product-unit-price'))return;
 customElements.define('rp-product-unit-price',class extends HTMLElement{
  connectedCallback(){
   this.root=this.closest('product-info');
   this.observer=new MutationObserver(()=>this.update());
   const pricing=this.root.querySelector('.product-plan');
   if(pricing)this.observer.observe(pricing,{subtree:true,childList:true,characterData:true});
   this.update();
  }
  update(){
   const rows=[...this.root.querySelectorAll('[data-role="unit"]')].map(e=>({text:e.textContent.trim(),value:Number(e.textContent.replace(/[^\d.]/g,''))})).filter(e=>e.value>0);
   if(!rows.length)return;
   const cheapest=rows.reduce((a,b)=>a.value<b.value?a:b);
   this.textContent='From '+cheapest.text;
  }
  disconnectedCallback(){this.observer?.disconnect()}
 });
})();
